import { detailUserInfo } from "./api.js"
export default {
    data() {
        return {
            // 是否登录
            isLogin: false,
            // 个人信息
            userInfo: null,
        }
    },
    created() {
        let lang = '';
        // 处理token
        const token = window.$CCDK.CCToken.getToken('binding', 'partnerToken');
        if (token) {
            // 获取用户信息
            detailUserInfo().then((res) => {
                if (res.result) {
                    // 设置用户信息
                    window.$CCDK.CCUser.setUserInfo(
                        res.data,
                        undefined,
                        'partnerUserInfo'
                    );
                    // 用户信息
                    this.userInfo = res.data;
                    lang = this.userInfo.language;
                    // 已登录
                    this.isLogin = true;
                } else {
                    console.error(res.returnInfo);
                }
            });
        } else {
            // 未登录
            this.isLogin = false;
        }
        if (!lang) {
            lang = navigator.language.toLowerCase();
            // 只保留主语言代码
            lang = lang.split("-")[0];
            // 如果不是支持的语言,默认使用英语
            if (!["zh", "en", "ja"].includes(lang)) {
                lang = "en";
            }
        }
        this.$i18n.locale = lang;
        this.curLang = lang;
    }
}